<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <v-alert :text="error" v-if="error" type="error" variant="tonal" density="compact" closable></v-alert>
      <v-row align="center">
        <v-col cols="5">
          <v-file-input variant="underlined" accept=".xlsx" chips
            label="Загрузить файл с задолженностями. Разрешенные типы файлов: xlsx"
            @update:modelValue="upload($event)"></v-file-input>
        </v-col>
        <v-col cols="2">
          <v-tooltip location="top" text="Загрузить пример" max-width="800">
            <template v-slot:activator="{ props }">
              <a v-bind="props" target="_blank"
                :href="$model.wwwroot + '/blocks/psm_desktop2/widgets/studentDebt/example.xlsx'">
                <v-icon color="green">mdi-microsoft-excel</v-icon>
              </a>
            </template>
          </v-tooltip>
          <v-tooltip location="top" text="Удалить все записи" max-width="800">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" @click="deleteAll()" color="red">mdi-delete</v-icon>
            </template>
          </v-tooltip>
        </v-col>

        <v-col cols="5">
          <v-text-field style="padding-bottom: 25px;" v-model="search" label="Поиск" prepend-inner-icon="mdi-magnify" variant="underlined"
            hide-details single-line></v-text-field>
        </v-col>
      </v-row>

      <v-data-table v-if="debt.length" :items="debt" class="elevation-1 nowrap" items-per-page="-1" hide-default-footer
        hide-default-header height="400" :search="search">
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <a target="_blank"
                :href="$model.wwwroot + '/blocks/manage_groups/personal/personal-card.php?user_id=' + item.uid">
                {{ item.lastname }} {{ item.firstname }}</a>
            </td>
            <td><span v-html="item.text_mess"></span></td>
            <td>
              <v-tooltip location="top" text="Удалить запись" max-width="800">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click="deleteRecord(item.id)" color="red">mdi-delete</v-icon>
                </template>
              </v-tooltip>
            </td>
          </tr>
        </template>


        <template v-slot:bottom> </template>
      </v-data-table>

    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="green" icon="mdi-cash"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Задолженности студентов</span>
      </v-col>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "studentDebtWidget",
  data() {
    return {
      load: false,
      debt: [],
      error: null,
      search: ""
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.debt.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.error = null;
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/studentDebt/getAll",
        )
        .then((response) => {
          this.debt = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          this.error = error.response.data;
        });
    },
    deleteAll() {
      this.error = null;
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/studentDebt/deleteAll",
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          this.load = false;
          this.error = error.response.data;
        });
    },
    deleteRecord(id) {
      this.error = null;
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/studentDebt/deleteRecord",
          new URLSearchParams({
            id: id,
          }),
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          this.load = false;
          this.error = error.response.data;
        });
    },
    upload(file) {
      if (file == undefined) {
        return;
      }
      this.load = true;
      this.error = null;
      let formData = new FormData();
      formData.append("debt", file, file.name);
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/psm_desktop2/widgets/studentDebt/upload",
          formData
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          this.load = false;
          this.error = error.response.data;
        });
    },
  },
};
</script>